import { Outlet } from 'react-router';
import { DawnPatrolLogo } from '@/components/ui/DawnPatrolLogo';

/**
 * Shell shared by every route: skip link, header, main landmark, footer.
 * Pages render into the `Outlet` and own only their own content.
 *
 * The background is a dawn horizon built in CSS — the site's hero uses a photo,
 * but hotlinking their CDN would add a third-party request on every load.
 */
export function RootLayout() {
    return (
        <div className="relative flex min-h-dvh flex-col overflow-hidden">
            <div
                aria-hidden="true"
                className="from-cyan/25 via-midnight to-midnight pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(120%_80%_at_50%_115%,var(--tw-gradient-stops))]"
            />
            <div
                aria-hidden="true"
                className="from-sand/20 pointer-events-none absolute inset-x-0 bottom-0 -z-10 h-1/3 bg-gradient-to-t to-transparent"
            />

            <a
                href="#main"
                className="bg-sand text-midnight sr-only rounded-full px-4 py-2 font-semibold focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-10"
            >
                Skip to content
            </a>

            <header className="border-linen/10 border-b">
                <div className="mx-auto flex w-full max-w-5xl items-center justify-between px-6 py-5">
                    <a
                        href="https://www.dawnpatrol.cloud"
                        className="text-linen"
                    >
                        <DawnPatrolLogo className="h-8 w-auto" />
                    </a>
                </div>
            </header>

            <main
                id="main"
                className="mx-auto flex w-full max-w-5xl flex-1 px-6"
            >
                <Outlet />
            </main>

            <footer className="border-linen/10 text-linen-faint border-t px-6 py-6 text-center text-sm">
                © {new Date().getFullYear()} Dawn Patrol Surf Tracking B.V.
            </footer>
        </div>
    );
}
